import Layout from '@/AppMain.vue';

const websites = {
    path: '/websites',
    name: 'Websites',
    component: Layout,
    children:[
        {
            path: '/',
            name: 'Websites',
            component: () => import('@/views/websites/browse'),
            meta: {title: 'Websites', auth: true, name:'Browse stores', back:'/', breadcrumbs: [{title: 'Dashboard', to: '/'}]}
        },
        {
            path: 'design',
            name: 'Websites',
            component: () => import('@/views/websites/design'),
            meta: {title: 'Website design', auth: true, user_permission:'edit_design', name:'Store design', back:'/websites', breadcrumbs: [{title: 'Dashboard', to: '/'}, {title:'Stores', to:'/websites'}]}
        },
        {
            path: 'design/edit/:id',
            name: 'Websites',
            component: () => import('@/views/websites/edit'),
            meta: {title: 'Website design', auth: true, user_permission:'edit_design', name:'Store design', back:'/websites', breadcrumbs: [{title: 'Dashboard', to: '/'}, {title:'Stores', to:'/websites'}]}
        },
        {
            path: 'create',
            name: 'Websites',
            component: () => import('@/views/websites/website-creation'),
            meta: {title: 'Website creation', auth: true, name: 'Website creation', back: '/', breadcrumbs: [{title: 'Dashboard', to: '/'}, {title:'Stores', to:'/websites'}]}
        },
        {
            path: 'edit/:id?',
            name: 'Websites',
            component: () => import('@/views/websites/website-edit'),
            meta: {title: 'Website creation', auth: true, name: 'Edit website', back: '/', breadcrumbs: [{title: 'Dashboard', to: '/'}, {title:'Stores', to:'/websites'}]}
        }
    ]
};
export default websites;
